<!-- resources/js/components/HeaderComponent.vue -->

<template>
	<div vw class="enabled">
		<div vw-access-button class="active"></div>
		<div vw-plugin-wrapper></div>
	</div>
	<noscript>Este site requer JavaScript para funcionar corretamente. Por favor, habilite o JavaScript.</noscript>

	<header style="margin-bottom: 5em;">
		<div id="acessibilidade" style="position: fixed; z-index: 1; width: 100%; top: 0;">
			<p style="text-align: center; width: 100%; padding: 0px; margin: 0px; background-color: #005580; color: #f8f8f8; font-size: small;">
				<a href="#" class="texto-branco">Ir para conteúdo</a>&nbsp;&nbsp;
				<a href="#" class="texto-branco">Ir para menu</a>&nbsp;&nbsp;
				<a href="#" class="texto-branco">A+</a>&nbsp;&nbsp;
				<a href="#" class="texto-branco">A-</a>&nbsp;&nbsp;
				<a href="#" class="texto-branco"><i class="fa fa-adjust" aria-hidden="true"></i></a>&nbsp;&nbsp;
				<a href="#" class="texto-branco" id="btn-vlibras" title="Habilitar o tradutor para libras" @click="habilitarVLibras">
					<img :src="`${BASE_URL}imagens/icons/maos_libras.png`" aria-hidden="true" /> Libras
				</a>&nbsp;&nbsp;
				<a href="#" class="texto-branco">Acessibilidade</a>&nbsp;&nbsp;
			</p>

			<nav class="navbar navbar-primary" style="background-image: linear-gradient(to left, #12b1d1, #006599); z-index: 2;">
				<div class="container-fluid">
					<!-- Botão de alternância (hamburguer) para telas pequenas -->
					<button class="navbar-toggler custom-toggler-icon" @click="toggleMenu">
						<i class="fas fa-bars" style="color: white;"></i>
					</button>

					<!-- Logo ou título do site -->
					<a v-if="Object.keys(user).length === 0" class="navbar-brand texto-branco-titulo ms-2 me-auto" style="font-size: 100%;" href="#">
						{{ EPROC_NOME_TRIBUNAL }}
					</a>
					<div v-if="Object.keys(user).length > 0" class="navbar-brand texto-branco-titulo ms-2 me-auto" style="font-size: small; padding: 0px;">
						<a :href="`${BASE_URL}`"><img :src="`${BASE_URL}imagens/logo_eproc_interna.png`" alt="Logo" class="logo" width="30px"></a>
						<label style="margin-left: 20px;"><strong>{{ EPROC_ESTADO }}</strong></label>
						<select style="margin-left: 10px;" class="custom-select">
							<option value="">{{ user.oab }} - ADVOGADO(A)</option>
						</select>
					</div>

					<div v-if="Object.keys(user).length > 0" style="margin-left: auto; display: flex; align-items: left;">


						<a style="color: white; font-size: 22px; margin-right: 10px;">
							<strong>jus.br&nbsp;&nbsp;|</strong>
						</a>

						<a :href="`${BASE_URL}home`" style="color: white; font-size: 24px; margin-right: 10px; vertical-align: middle;">
							<i class="fa fa-home" style="color: white; font-size: 24px;"></i>
						</a>

						<input type="text" class="form-control" placeholder="Nº de Processo" style="margin-left: 10px; font-size: small;">
						<span class="material-icons" style="color: white; font-size: 34px; margin-left: 10px; cursor: pointer;" @click="toggleUserMenu">
							account_circle
						</span>
					</div>
					<!-- Menu do ícone de usuário -->
					<div v-if="userMenuVisible" class="user-menu" style="padding: 0px; font-size: small;">
						<ul>
							<li style="background-color: black; color: white;"><a href="#" style="color: white;">{{ user.name }} ({{ user.oab }})</a></li>
							<hr style="padding: 0px;" />
							<li>
								<a href="#" style="color: black;"><span class="material-icons" style="font-size: 20px; vertical-align: middle;">newspaper</span>&nbsp;Novidades</a>
							</li>
							<li>
								<a href="#" style="color: black;"><span class="material-icons" style="font-size: 20px; vertical-align: middle;">settings</span>&nbsp;Configurações</a>
							</li>
							<li>
								<a href="#" style="color: black;"><span class="material-icons" style="font-size: 20px; vertical-align: middle;">accessibility_new</span>&nbsp;Barra de acessibilidade</a>
							</li>
							<hr style="padding: 0px;" />
							<li>
								<a :href="`${BASE_URL}logout`" style="color: black;"><span class="material-icons" style="font-size: 20px; vertical-align: middle;">exit_to_app</span>&nbsp;Encerrar Sessão (Ctrl+Shift+F4)</a>
							</li>
						</ul>
					</div>

				</div>
			</nav>
		</div>
	</header>


	<div :class="{ 'menu-lateral container': true, 'show container': isMenuOpen }">
		<!-- Menu deslogado -->
		<ul v-if="Object.keys(user).length === 0" class="navbar-nav" style="margin-top: 5em;">
			<input type="text" placeholder="Pesquisar no Menu (Alt + m)" class="input-arredondado" v-model="campo_pesquisa_menu_lateral" />

			<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Acessibilidade</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}login`" class="nav-link">Entrar no Sistema</a></li>

			<li class="nav-item" @click="toggleSubmenu('cadastre-se')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Cadastre-se AQUI!
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('cadastre-se') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('cadastre-se')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}register`" class="nav-link">Cadastrar Advogado</a></li>

					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Cadastrar Representante Legal de PJ</a></li>
				</ul>
			</li>

			<li class="nav-item" @click="toggleSubmenu('consulta-autenticidade')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Consulta Autenticidade
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('consulta-autenticidade') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('consulta-autenticidade')" class="submenu">
					<!-- Subitens de Consulta Autenticidade -->
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Certidão Narratória</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Certidão de Execução</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Documentos</a></li>
				</ul>
			</li>

			<li class="nav-item"><a :href="`${BASE_URL}about`" class="nav-link">Consulta Guia de Custas</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}about`" class="nav-link">Audiências</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}about`" class="nav-link">Consulta Pública de Processos</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}processos/consulta_chave_proc/`" class="nav-link">Consulta de Documento por Chave</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}about`" class="nav-link">Fale Conosco</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}about`" class="nav-link">Fórum de Conciliação</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}about`" class="nav-link">Legislação</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}about`" class="nav-link">Sessões de Julgamento</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}about`" class="nav-link">Tutoriais</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}about`" class="nav-link">Sobre o Simulador</a></li>
		</ul>

		<!-- Menu logado -->
		<ul v-if="Object.keys(user).length > 0" class="navbar-nav" style="margin-top: 5em;">
			<input type="text" placeholder="Pesquisar no Menu (Alt + m)" class="input-arredondado" v-model="campo_pesquisa_menu_lateral" />

			<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Menu Textual</a></li>
			<li class="nav-item" @click="toggleSubmenu('alvara-eletronico')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Alvará Eletrônico Automatizado
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('alvara-eletronico') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('alvara-eletronico')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Consulta Alvara Eletrônico Automatizado</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Relatório Alvarás Eletrônico por Advogado</a></li>
				</ul>
			</li>
			<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Associar Assistente ao Advogado</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Atendimento a Tutoriais</a></li>
			<li class="nav-item" @click="toggleSubmenu('consulta-processual')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Consulta Processual
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('consulta-processual') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('consulta-processual')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}processos/consultar`" class="nav-link">Consulta Processos</a></li>
				</ul>
			</li>
			<li class="nav-item" @click="toggleSubmenu('custas')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Custas
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('custas') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('custas')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Consulta Indisponibilidades de Registro de Custas</a></li>
				</ul>
			</li>
			<li class="nav-item" @click="toggleSubmenu('depositos-judiciais')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Depósitos Judiciais
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('depositos-judiciais') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('depositos-judiciais')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Guias Depósito Judicial</a></li>
				</ul>
			</li>
			<li class="nav-item" @click="toggleSubmenu('mensagens')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Mensagens
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('mensagens') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('mensagens')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Caixa de Mensagens</a></li>
				</ul>
			</li>
			<li class="nav-item" @click="toggleSubmenu('movimentacao-processual')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Movimentação Processual
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('movimentacao-processual') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('movimentacao-processual')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Temas Repetitivos em Bloco</a></li>
				</ul>
			</li>
			<li class="nav-item"><a :href="`${BASE_URL}home`" class="nav-link">Painel do Advogado</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Paradas do Sistema</a></li>
			<li class="nav-item"><a :href="`${BASE_URL}processos/novo`" class="nav-link">Petição Inicial</a></li>
			<li class="nav-item" @click="toggleSubmenu('peticao-movimentacao')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Petição/Movimentação
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('peticao-movimentacao') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('peticao-movimentacao')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Petição/Movimentação em Bloco</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Petição/Movimentação Individual</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Petição/Movimentação por Evento Gerado</a></li>
				</ul>
			</li>
			<li class="nav-item" @click="toggleSubmenu('relatorios')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Relatórios
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('relatorios') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('relatorios')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}relatorio_processo`" class="nav-link">Relação de Processos</a></li>
				</ul>
			</li>
			<li class="nav-item" @click="toggleSubmenu('substabelecimento')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Substabelecimento
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('substabelecimento') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('substabelecimento')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Substabelecimento em Bloco</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Substabelecimento individual</a></li>
				</ul>
			</li>
			<li class="nav-item" @click="toggleSubmenu('tabelas-basicas')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Tabelas Básicas
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('tabelas-basicas') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('tabelas-basicas')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Assuntos Judiciais</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Classe Judicial</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Evento/Petição Tipo Documento</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Tipo Petição Judicial</a></li>
				</ul>
			</li>
			<li class="nav-item" @click="toggleSubmenu('tutorial')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Tutorial
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('tutorial') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('tutorial')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}acessibilidade`" class="nav-link">Acessibilidade</a></li>
				</ul>
			</li>
			<li class="nav-item" @click="toggleSubmenu('usuarios')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Usuários
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('usuarios') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('usuarios')" class="submenu">
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Alteração de Dados Pessoais</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Alterar Senha Pessoal</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Cadastro de Usuários</a></li>
				</ul>
			</li>
			<li v-if="user.is_admin" class="nav-item" @click="toggleSubmenu('administrador')" style="cursor: pointer;">
				<span class="nav-link flex-container">
					Administrador
					<span class="seta" :class="{ 'seta-cima': isSubmenuOpen('administrador') }">&#9660;</span>
				</span>
				<ul v-if="isSubmenuOpen('administrador')" class="submenu">
					<li v-if="user.is_admin && ATIVAR_ASSISTENTE_JURIDICO" class="nav-item">
						<a :href="`${BASE_URL}admin/assistente-juridico/conhecimentos`" class="nav-link">Assistente Jurídico</a>
					</li>
					<!-- Subitens de Cadastre-se AQUI! -->
					<li class="nav-item"><a :href="`${BASE_URL}distribuicao_lote`" class="nav-link">Distribuição em Lote <span class="badge-new">(novo)</span></a></li>
					<li class="nav-item"><a :href="`${BASE_URL}pendentes`" class="nav-link">Alunos pendentes</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}cadastro/assuntos`" class="nav-link">Assuntos</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}cadastro/ritos`" class="nav-link">Ritos</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}cadastro/ritos_area`" class="nav-link">Ritos - Área</a></li>
					<!-- <li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Cadastro de Seção</a></li> -->
					<!-- <li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Cadastro de Competência</a></li> -->
					<li class="nav-item"><a :href="`${BASE_URL}cadastro/classes`" class="nav-link">Cadastro de Classe Processual</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}cadastro/tp_pet`" class="nav-link">Cadastro de Eventos da Petição</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}cadastro/tp_docpet`" class="nav-link">Tipos de Documentos da Petição</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}cadastro/info_adicionais`" class="nav-link">Informações Adicionais do Processo</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}cadastro/motivos_prioridade_peticao`" class="nav-link">Motivos de Prioridade da Petição</a></li>
					<!-- <li class="nav-item"><a :href="`${BASE_URL}`" class="nav-link">Cadastro de Tipo de doc Anexo</a></li> -->
					<li class="nav-item"><a :href="`${BASE_URL}cadastro/turma`" class="nav-link">Cadastro de Turmas</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}consulta_aluno`" class="nav-link">Cadastro de Alunos/Usuários</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}cadastro_grupos`" class="nav-link">Cadastro de Grupos</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}cadastro_competencias`" class="nav-link">Cadastro de Competências</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}cadastro/cidades`" class="nav-link">Cadastro de Cidades</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}relatorio_processo`" class="nav-link">Relatório de Processos</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}relatorio_acessos`" class="nav-link">Relatório de Acessos</a></li>
					<li class="nav-item"><a :href="`${BASE_URL}docs/ePROC_menu_administrador.pdf`" class="nav-link" target="_blank">Manual do Administrador</a></li>
				</ul>
			</li>
			<li class="nav-item"><a :href="`${BASE_URL}about`" class="nav-link">Sobre o Simulador</a></li>
		</ul>

	</div>

</template>

<script>
	export default {
		props: {
			user: {
				type: Object,
				required: true,
			},
		},
		data() {
			return {
				BASE_URL: window.Laravel.baseUrl,
				EPROC_ESTADO: window.Laravel.EPROC_ESTADO,
				EPROC_NOME_TRIBUNAL: window.Laravel.EPROC_NOME_TRIBUNAL,
				ATIVAR_ASSISTENTE_JURIDICO: window.Laravel.ATIVAR_ASSISTENTE_JURIDICO,

				isMenuOpen: true,
				openSubmenus: [], // Array para rastrear submenus abertos
				userMenuVisible: false,
				campo_pesquisa_menu_lateral: '',
			};
		},
		methods: {
			habilitarVLibras() {
				document.querySelector('[vw-access-button]').click();
			},
			toggleMenu() {
				this.isMenuOpen = !this.isMenuOpen;
				this.$store.commit('toggleMenu');
			},

			toggleSubmenu(submenu) {
				const index = this.openSubmenus.indexOf(submenu);

				if (index === -1) {
					this.openSubmenus.push(submenu);
				} else {
					this.openSubmenus.splice(index, 1);
				}
			},
			isSubmenuOpen(submenu) {
				return this.openSubmenus.includes(submenu);
			},

			toggleUserMenu() {
				this.userMenuVisible = !this.userMenuVisible;
			},
			showUserData() {
				// Lógica para exibir os dados pessoais
				// Fechar o menu após a ação
				this.userMenuVisible = false;
			},
			logout() {
				// Lógica para logout
				console.log("Logout");
				// Redirecionar para a página de login, por exemplo
				// this.$router.push('/login');
			},



		},
		mounted() {
			const script = document.createElement('script');
			script.src = 'https://vlibras.gov.br/app/vlibras-plugin.js';
			script.async = true;
			script.defer = true;
			script.onload = () => {
				new window.VLibras.Widget('https://vlibras.gov.br/app');
			};
			document.head.appendChild(script);
			console.log('EPROC_ESTADO', this.EPROC_ESTADO);
			console.log('Assitente Juridico:', this.ATIVAR_ASSISTENTE_JURIDICO);
		},

	};
</script>

<style scoped>
	.texto-branco {
		color: white;
		text-decoration: none;
	}

	.texto-branco:hover {
		color: #12b1d1;
		text-decoration: none;
	}

	.texto-branco-titulo {
		text-decoration: none;
		color: #fff;
		/* Define a cor desejada ao passar o mouse */
	}

	.texto-branco-titulo:hover {
		text-decoration: none;
		color: #fff;
		/* Define a cor desejada ao passar o mouse */
	}

	.custom-toggler-icon {
		border: 0;
	}

	.custom-toggler-icon:hover {
		opacity: 90%;
		background-color: #60bcce;
	}

	.input-arredondado {
		margin-bottom: 15px;
		border-radius: 6px;
		/* Ajuste o valor conforme necessário para obter o arredondamento desejado */
		padding: 4px;
		/* Ajuste o espaçamento interno conforme necessário */
		border: 1px solid #ccc;
		/* Adicione uma borda para melhorar a aparência */
		/* Adicione outros estilos conforme necessário */
	}


	.menu-lateral {
		position: fixed;
		top: 0;
		left: -277px;
		/* Posição inicial fora da tela */
		width: 20%;
		max-width: 277px;
		height: 100%;
		background-color: #2e373c;
		/* Cor de fundo do menu (quase preto) */
		color: #ffffff;
		/* Cor do texto (branco) */
		transition: 0.5s;
		/* Adiciona uma transição suave de 0.5 segundos */
		z-index: 0;
		font-size: 0.95rem;
		overflow-x: hidden;
	}

	.menu-lateral.show {
		left: 0;
		/* Posição para exibir o menu na tela */
		transition: 0.5s;
		/* Adiciona uma transição suave de 0.5 segundos */
	}


	.nav-item:hover {
		background-color: #465259;
	}



	.submenu {
		background: rgba(255, 255, 255, .07);
		margin: 0;
		list-style-type: none;
	}


	.flex-container {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}


	.seta {
		margin-left: 0.2em;
		transition: transform 0.3s ease;
		font-size: x-small;
	}

	.seta-cima {
		transform: rotate(180deg);
		transition: transform 0.3s ease;
		/* Adiciona uma transição suave de 0.3 segundos */
		font-size: x-small;
	}


	/* Estiliza o select para parecer com o form-select do Bootstrap */
	.custom-select {
		display: inline;
		padding: 0.375rem 1.25rem 0.375rem 0.75rem;
		font-size: 0.75rem;
		font-weight: 400;
		line-height: 1.5;
		color: #495057;
		background-color: #fff;
		background-clip: padding-box;
		border: 1px solid #ced4da;
		border-radius: 0.25rem;
		transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	}

	.user-menu {
		position: absolute;
		cursor: pointer;
		top: 60px;
		/* Ajuste conforme necessário */
		right: 10px;
		/* Ajuste conforme necessário */
		background: #fff;
		border: 1px solid #ccc;
		padding: 10px;
		z-index: 999;
	}

	.user-menu ul {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.user-menu li {
		cursor: pointer;
		padding: 5px;
		margin: 5px 0;
	}



	.user-menu a {
		text-decoration: none;
	}


	.user-menu a:hover {
		text-decoration: underline;
	}

	.nav-item {
		font-size: 14px;
	}

	.nav-link {
		padding: 5px;
	}



	/* A tagzinha de novo on menu */
	.nav-link {
		display: flex !important;
		align-items: center;
		white-space: nowrap;
		/* Impede que o texto quebre se o menu for estreito */
	}

	.badge-new {
		display: inline-block;
		/* Essencial para a animação de escala funcionar */
		background-color: #28a745;
		color: white;
		font-size: 10px;
		/* Um pouco menor para não brigar com o texto */
		font-weight: bold;
		padding: 2px 8px;
		border-radius: 50px;
		/* Deixa bem arredondado */
		margin-left: 8px;
		text-transform: uppercase;
		line-height: 1;
		/* Evita que o badge aumente a altura da linha */

		/* Animação */
		animation: pulse-animation 2s infinite;
	}

	/* No Vue scoped, defina o keyframe com um nome bem específico */
	@keyframes pulse-animation {
		0% {
			transform: scale(1);
			box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
		}

		70% {
			transform: scale(1.1);
			box-shadow: 0 0 0 5px rgba(40, 167, 69, 0);
		}

		100% {
			transform: scale(1);
			box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
		}
	}

</style>
